import Radium from 'radium';
import React from 'react';
import PropTypes from 'prop-types';
import Styles from './ProjectListFooter.styles';

const Footer = props => <div style={Styles.footer}>{props.children}</div>;

Footer.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Radium(Footer);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListFooter/ProjectListFooter.js